import type { RouteRecordRaw } from 'vue-router'

const oaRoutes: RouteRecordRaw = {
  path: '/oa',
  name: 'OA',
  redirect: '/oa/approval',
  meta: { title: 'OA办公', icon: 'icon-apps' },
  children: [
    { path: 'approval', name: 'OaApproval', component: () => import('@/views/oa/ApprovalCenter.vue'), meta: { title: '审批中心' } },
    { path: 'clockin', name: 'OaClockIn', component: () => import('@/views/oa/ClockIn.vue'), meta: { title: '考勤打卡' } },
    { path: 'announcement', name: 'OaAnnouncement', component: () => import('@/views/oa/AnnouncementList.vue'), meta: { title: '公告通知' } },
  ],
}

export default oaRoutes
